import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
export const ModuleTitle = ({ title, backToMenu }: {title: string, backToMenu?: () => void}) => {
  return (
    <div className="row">
      <h1 className="text-center d-flex flex-row w-100 title">
        {backToMenu && <button type="button" onClick={() => backToMenu()} className='pl-4 my-auto back-arrow'>
          <FontAwesomeIcon icon={faArrowLeft} size="2x" />
        </button>}
        <div className='flex-fill my-auto'>{title}</div>
      </h1>
    </div>
  )
}
